import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/components/AccountsPage/AccountsPage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/components/MobileApp/AccountsPageMobile/AccountsPageMobile.jsx");
